import { CButton, CCard, CCardBody, CCardFooter, CCardHeader, CCardTitle, CFormLabel, CFormSelect, CModal, CModalBody, CModalFooter, CTooltip, CModalHeader, CModalTitle, CHeader } from '@coreui/react'
import React, { useEffect, useState, useRef } from 'react'
import ModalFormBuilder from './ModalFormBuilder'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'

import Select from 'react-select'
import { CircleAlertIcon, Pencil, Trash2, ListOrdered, Info } from 'lucide-react'
import SaveQuestionProvider from '../../services/general/saveQuestionsProvider.api'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import MultiSelect from '../../components/shared/MultiSelect'
import SaveExtra from '../../services/general/saveExtraData.api'
import DisplayQuestion from '../../components/shared/DisplayQuestion'

const Incident = () => {
  const [isModalOpen, setIsOpenModal] = useState(false)
  const [diagnosisData, setDiagnosisData] = useState([])
  const [allQuestions, setAllQuestions] = useState([])
  const [fetchedQuestions, setFetchedQuestions] = useState([])
  const [viewQuestions, setViewQuestions] = useState(false)
  const [newQuestions, setNewQuestions] = useState([])
  const [selectedDiagnosis, setSelectedDiagnosis] = useState(null)
  const [selectedEditDiagnosisQuestion, setSelectedEditDiagnosisQuestion] = useState(null)
  const [selectedEditDiagnosisQuestionIndex, setSelectedEditDiagnosisQuestionIndex] = useState(null)
  const [draggedIndex, setDraggedIndex] = useState(null)
  const [callAddFromMade, setCallAddFromMade] = useState(false)
  const [deleteVisible, setDeleteVisible] = useState(false)
  const [questionType, setQuestionType] = useState('')
  const [deleteQuestionIndex, setDeleteQuestionIndex] = useState(null)
  const [linkedOptions, setLinkedOptions] = useState({})
  const [ExtraDiagnosis, setExtraDiagnosis] = useState([])

  //  const [mode, setMode] = useState("Add")

  const mode = useRef('Add')
  const [inputValues, setInputValues] = useState({})

  const handleInputChange = (e, id) => {
    setInputValues((prevValues) => ({
      ...prevValues,
      [id]: e.target.value,
    }))
  }

  const getData = async () => {
    let a = await GetDiagnosisData()
    let data = JSON.parse(a.d)
    let options = []
    data.Data.map((obj) => {
      options.push({
        value: obj.id,
        label: obj.Name.trim(),
      })
    })
    let extraDiagnosis = await SaveExtra('Get_By_Type', 'incidentDiagnosis', '', '')
    if (extraDiagnosis) {
      extraDiagnosis = JSON.parse(extraDiagnosis.d)?.Data || []

      extraDiagnosis = extraDiagnosis[0] || []
      if (extraDiagnosis.JsonData) {
        extraDiagnosis = {
          ...extraDiagnosis,
          JsonData: JSON.parse(extraDiagnosis.JsonData),
        }
      }
    }

    setExtraDiagnosis(extraDiagnosis)
    if (extraDiagnosis.JsonData) {
      setDiagnosisData([...options, ...extraDiagnosis.JsonData])
    } else {
      setDiagnosisData(options)
    }
  }

  const GetFormDataForDiagnosis = async () => {
    let formattedData
    formattedData = await SaveQuestionProvider('GET', '', 'Incident', selectedDiagnosis?.value?.toString(), '')

    if (formattedData) {
      formattedData = JSON.parse(formattedData.d)?.Data || []
      formattedData = formattedData[0] || []

      if (formattedData.questionData) {
        formattedData = {
          ...formattedData,
          questionData: JSON.parse(formattedData.questionData).filter((item) => item !== null),
        }
      }
      setFetchedQuestions(formattedData)
    }
  }

  useEffect(() => {
    if (selectedDiagnosis) {
      GetFormDataForDiagnosis()
    }
  }, [selectedDiagnosis])

  useEffect(() => {
    getData()
  }, [])

  const addFormMade = async () => {
    if (selectedDiagnosis) {
      if (selectedDiagnosis.__isNew__) {
        if (ExtraDiagnosis.Id) {
          await SaveExtra('Update', 'incidentDiagnosis', JSON.stringify([selectedDiagnosis, ...ExtraDiagnosis.JsonData]), ExtraDiagnosis.Id)
        } else {
          await SaveExtra('Insert', 'incidentDiagnosis', JSON.stringify([selectedDiagnosis]))
        }
      }
    }
    if (Object.entries(fetchedQuestions).length > 0) {
      if (selectedEditDiagnosisQuestion) {
        await SaveQuestionProvider('UPDATE', fetchedQuestions.id.toString(), 'Incident', selectedDiagnosis?.value?.toString(), JSON.stringify([...fetchedQuestions.questionData]))
      } else {
        await SaveQuestionProvider('UPDATE', fetchedQuestions.id.toString(), 'Incident', selectedDiagnosis?.value?.toString(), JSON.stringify([...fetchedQuestions.questionData, ...allQuestions]))
        GetFormDataForDiagnosis()
        setAllQuestions([])
      }
    } else {
      await SaveQuestionProvider('INSERT', '', 'Incident', selectedDiagnosis?.value?.toString(), JSON.stringify(allQuestions))
      GetFormDataForDiagnosis()
      setAllQuestions([])
    }
  }

  const handleDragStart = (e, idx) => {
    e.dataTransfer.setData('questionIndex', idx)
  }

  const handleDrop = (e, idx) => {
    const draggedQuestionIndex = e.dataTransfer.getData('questionIndex')
    if (draggedQuestionIndex === idx) return // Prevent reordering the same item

    const reorderedQuestions = [...fetchedQuestions.questionData]
    const [draggedQuestion] = reorderedQuestions.splice(draggedQuestionIndex, 1)
    reorderedQuestions.splice(idx, 0, draggedQuestion)

    setFetchedQuestions((prevState) => ({
      ...prevState,
      questionData: reorderedQuestions,
    }))
  }

  const handleDragOver = (e) => {
    e.preventDefault()
  }

  if (callAddFromMade == true) {
    addFormMade()
    setCallAddFromMade(false)
  }

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

  const handleResize = () => {
    setIsMobile(window.innerWidth < 768)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const deleteQuestion = async (idx) => {
    try {
      setFetchedQuestions((prevState) => ({
        ...prevState,
        questionData: prevState.questionData.filter((_, i) => i !== idx),
      }))
      const updatedQuestions = fetchedQuestions.questionData.filter((_, i) => i !== idx)
      await SaveQuestionProvider('UPDATE', fetchedQuestions.id.toString(), 'Incident', selectedDiagnosis?.value?.toString(), JSON.stringify(updatedQuestions))
    } catch (error) {
      console.error('Error updating question data:', error)
    }
    GetFormDataForDiagnosis()
    setAllQuestions([])
    setDeleteVisible(false)
  }

  const handleEditQuestion = (question, index) => {
    setSelectedEditDiagnosisQuestion(question)
    setSelectedEditDiagnosisQuestionIndex(index)
    mode.current = 'Edit'
    setIsOpenModal(true)
  }

  const handleSelectionChange = (selectedValues) => {}

  return (
    <>
      <CModal visible={deleteVisible} onClose={() => setDeleteVisible(false)}>
        <CModalHeader>
          <CModalTitle>Warning</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <p>Are you sure you want to delete?</p>
        </CModalBody>

        <CModalFooter>
          <CButton
            onClick={() => {
              setDeleteVisible(false)
            }}
            className="text-white"
            color="secondary"
          >
            Close
          </CButton>
          <CButton onClick={() => deleteQuestion(deleteQuestionIndex)} className="text-white" color="danger">
            Delete
          </CButton>
        </CModalFooter>
      </CModal>
      <div className="d-flex flex-column flex-md-row justify-content-between text-small bg-white" style={{ width: '90vw', height: '100vh' }}>
        <div className="  px-1 px-sm-5 " style={{ width: isMobile ? '100%' : '45%' }}>
          <CCard title="Diagnosis" className="my-4 shadow " style={{ border: 'none' }}>
            <CCardHeader className=" text-white text-center p-2  " style={{ background: '#F7F7F8' }}>
              <CCardTitle className="font-weight-bold mb-0   " style={{ fontSize: '0.9rem' }}>
                Select Diagnosis For Incident Questions
              </CCardTitle>
            </CCardHeader>
            <CCardBody className="rounded">
              <div className="mb-5 mx-auto w-75">
                <CFormLabel className="font-weight-bold">Select Diagnosis</CFormLabel>
                <MultiSelect
                  value={selectedDiagnosis}
                  onChange={(e) => {
                    setSelectedDiagnosis(e)
                  }}
                  options={diagnosisData}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select or create Diagnosis"
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      borderColor: '#ced4da',
                      boxShadow: 'none',
                      '&:hover': {
                        borderColor: '#80bdff',
                      },
                    }),
                  }}
                />
              </div>
            </CCardBody>
            <CCardFooter className="d-flex justify-content-between text-small  " style={{ border: '', background: 'white' }}>
              <div className="d-flex gap-2">
                <CButton variant="outline" onClick={addFormMade} color="primary" className="mr-2" size="sm">
                  Save Form
                </CButton>
                {/* <CButton variant='outline' onClick={() => { setViewQuestions(true) }} color="primary" className="mr-2" size="sm" >Preview Form</CButton> */}
              </div>
              <CButton
                onClick={() => {
                  setSelectedEditDiagnosisQuestion(null)
                  setQuestionType('')
                  mode.current = 'Add'
                  setIsOpenModal(true)
                }}
                color="primary"
                disabled={selectedDiagnosis === null}
                size="sm"
              >
                {selectedDiagnosis === null ? 'Add Questions' : 'Add Questions'}
              </CButton>
            </CCardFooter>
          </CCard>
        </div>
        <div className="container-fluid " style={{ width: isMobile ? '100%' : '50%' }}>
          <div className="p-2 mt-4 border-bottom text-secondary shadow-sm" style={{ background: '#F7F7F8' }}>
            {' '}
            <span className="mx-2">
              <ListOrdered size={20} strokeWidth={1.5} />
            </span>{' '}
            Drag & Drop For Reordering Questions.
          </div>
          <div className="p-3 rounded shadow  bg-white overflow-auto  " style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(1, 1fr)' : 'repeat(1, 1fr)', gap: '1rem', maxHeight: '90vh', overflow: 'auto', background: '#ffffff' }}>
            <div>
              {fetchedQuestions.questionData && (
                <DisplayQuestion fetchedQuestions={fetchedQuestions} handleDragStart={handleDragStart} handleDragOver={handleDragOver} handleDrop={handleDrop} handleEditQuestion={handleEditQuestion} setDeleteVisible={setDeleteVisible} setDeleteQuestionIndex={setDeleteQuestionIndex} />
              )}
            </div>
          </div>
        </div>
      </div>
      <ModalFormBuilder
        mode={mode}
        newQuestions={newQuestions}
        setNewQuestions={setNewQuestions}
        fetchedQuestions={fetchedQuestions}
        setFetchedQuestions={setFetchedQuestions}
        selectedEditDiagnosisQuestion={selectedEditDiagnosisQuestion}
        selectedEditDiagnosisQuestionIndex={selectedEditDiagnosisQuestionIndex}
        allQuestions={allQuestions}
        setAllQuestions={setAllQuestions}
        setIsOpenModal={setIsOpenModal}
        isOpen={isModalOpen}
        onClose={() => setIsOpenModal(false)}
        setSelectedEditDiagnosisQuestion={setSelectedEditDiagnosisQuestion}
        addFormMade={addFormMade}
        setCallAddFromMade={setCallAddFromMade}
        diagnosisData={diagnosisData}
        selectedDiagnosis={selectedDiagnosis}
        questionType={questionType}
        setQuestionType={setQuestionType}
      />
      <CModal
        size="lg"
        onClose={() => {
          setViewQuestions(false)
        }}
        visible={viewQuestions}
      >
        <CModalHeader closeButton>
          <CModalTitle>Preview Form</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div className="">
            <div className="bg-white p-2 d-flex flex-column gap-4" style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(1, 1fr)' : 'repeat(1, 1fr)', gap: '1rem', maxHeight: '60vh', overflow: 'auto', background: '#ffffff' }}>
              {fetchedQuestions.questionData &&
                fetchedQuestions.questionData.map((ques, idx) => (
                  <div
                    key={idx}
                    draggable
                    onDragStart={(e) => handleDragStart(e, idx)}
                    onDrop={(e) => handleDrop(e, idx)}
                    onDragOver={handleDragOver}
                    className={`d-flex flex-column gap-3 p-3 mb-3 border  bg-white   shadow-sm    ${
                      ques?.type === 'input' && (ques?.condition === 'null' || !ques?.condition || ques?.condition?.multipleOptions?.includes(inputValues[ques?.condition?.questionId]))
                        ? 'visible'
                        : ques?.type === 'dropdown' && (!ques?.condition || (ques?.condition?.isShowOnCondition && ques?.condition?.multipleOptions?.includes(inputValues[ques?.condition?.questionId])))
                          ? 'visible'
                          : 'invisible d-none'
                    }`}
                    style={{ cursor: 'move', height: 'auto', borderRadius: '20px', maxWidth: '100%' }}
                  >
                    {ques?.type === 'input' ? (
                      <div className="d-flex flex-column gap-2 ">
                        <div className="d-flex justify-content-between align-items-center ">
                          <label className="fw-bold  " style={{ maxWidth: '400px' }}>
                            {ques?.label}
                          </label>
                          <CTooltip content={ques?.toolTipValue ? ques?.toolTipValue : 'Add the tooltip'}>
                            <Info size={16} />
                          </CTooltip>
                        </div>
                        {ques?.isTextArea ? (
                          <textarea value={inputValues[ques?.id]} onChange={(e) => handleInputChange(e, ques?.id)} placeholder="Enter your answer here..." className="form-control" rows="4" />
                        ) : (
                          <input type="text" onChange={(e) => handleInputChange(e, ques?.id)} value={inputValues[ques?.id]} placeholder="Enter your answer here..." className="form-control" />
                        )}
                      </div>
                    ) : (
                      // Dropdown Field
                      <div className={`d-flex flex-column gap-2    ${ques?.type === 'dropdown' && (!ques?.condition || (ques?.condition?.isShowOnCondition && ques?.condition?.multipleOptions?.includes(inputValues[ques?.condition?.questionId]))) ? 'visible' : 'invisible d-none'}`}>
                        <div className="d-flex justify-content-between align-items-center">
                          <label className="fw-bold  " style={{ maxWidth: '400px' }}>
                            {ques?.label}
                          </label>
                          <CTooltip content={ques?.toolTipValue ? ques?.toolTipValue : 'Add the tooltip'}>
                            <Info size={16} />
                          </CTooltip>
                        </div>
                        <Select
                          multiple={ques?.isMultiple}
                          options={ques?.options}
                          onChange={(e) => {
                            setInputValues((prev) => ({
                              ...prev,
                              [ques?.id]: e.label,
                            }))
                          }}
                          styles={{
                            menu: (provided) => ({
                              ...provided,
                              zIndex: 9999, // Apply custom z-index here
                            }),
                          }}
                        />
                      </div>
                    )}
                  </div>
                ))}
            </div>
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton onClick={() => setViewQuestions(false)} color="secondary">
            Close
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default Incident
